import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from '../../helper/controlservice';
import * as Actions from "../../redux/actions/loginAction";
import MaskedInput from 'react-text-mask'

const uuidv4 = require('uuid/v4');

class Textbox extends React.PureComponent {
    state = {
        touched: false,
        isExist: null,
        typingTimer: null,
        restictedWord: null,
        value: "",
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var nextData = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : null;
        if (nextData && nextData[nextProps.control.key] === undefined && prevState.touched) {
            return {
                value: '',
                touched: false
            };
        } else if (nextData) {
            return {
                value: nextData[nextProps.control.key] ? nextData[nextProps.control.key] : ''
            };
        }
        else return null; // Triggers no change in the state
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.value && this.state.value === undefined && this.state.touched === false) {
            this.props.update(this.props.control.key, this.state.value, this.props.formid)
        } else if (prevState && this.state.value != prevState.value) {
            this.controlVaildationCheck(this.props);
            this.setState({
                touched: true,
            });
            this.keyup(this.props.control, this.state.value);
        }
    }
    componentDidMount() {
        const { control } = this.props;
        debugger;
        if (control.AutoValidateOnLoad) {
            this.setState({ touched: this.state.value ? true : false });
            this.keyup(control, this.state.value);
        }
        this.controlVaildationCheck(this.props);
    }
    disablecopypaste(e, control) {

        return control.disablecopypaste ? false : true;
    }
    keyup(control, data, e) {
        if (control.queryfield && control.queryfield.trim()) {
            this.setState({ isExist: null });
            var doneTypingInterval = 500;  //time in ms, 5 second
            if (this.state.typingTimer) {
                clearTimeout(this.state.typingTimer);
                this.setState({ typingTimer: null });
            } else {
                this.setState({ typingTimer: setTimeout(this.doneTyping(control, data), doneTypingInterval) });
            }
        }
    }
    keypress(control, typingTimer, value, e) {
        if (typingTimer) {
            clearTimeout(this.state.typingTimer);
            this.setState({ typingTimer: null });
        }
        if (e.key == "Enter") {
            if (control.refreshcomponenton && control.refreshcomponenformid) {
                this.props.update(control.refreshcomponenton + '_refresh', uuidv4(), control.refreshcomponenformid + 'write')
            }
        }
    }
    doneTyping(control, data) {
        const apiparam = {};
        const url = control.apiurl;
        // var data = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {}
        if (control.apiparam) {
            control.apiparam.forEach(option => {
                apiparam[option.key] = option.value;
            })
        }
        apiparam[control.queryfield] = data;

        ControlService().ServiceRequest(url, apiparam, control, this.props.token, null)
            .then(
                (res) => {

                    var _data = null;
                    if (control.responsefield) {
                        _data = res ? res[control.responsefield] : [];
                    } else if (Array.isArray(res) && res.length > 0)
                        _data = res[0];
                    else if (typeof res == "object")
                        _data = res;

                    if (_data) {
                        this.setState({ isExist: _data[control.outputfield] });

                        if (control.enableforformvalidation) {
                            if (_data[control.outputfield]) {
                                this.props.update(control.key, { "status": "fail", "control": control, touched: false }, this.props.formid + "_validation");
                            } else {
                                this.props.update(control.key, { "status": "pass", "control": control, touched: false }, this.props.formid + "_validation")
                            }
                        }
                    }
                })
            .catch(err => {
                console.log(err);
            });
    }
    updatePageVarible(control, data, formid) {
        if (control.restrictedword && control.restrictedword.length > 0 && this.state.value) {
            if (control.restrictedword.find(x => x.toLowerCase().trim() === this.state.value.toLowerCase().trim())) {
                this.setState({ restictedWord: control.restrictedword.find(x => x.toLowerCase().trim() === this.state.value.toLowerCase().trim()) });
                // this.state.value = "";
                this.props.update(control.key, "", formid);
                this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation")
                // this._controlService.getCssforMandatory(control, this.state.value);
            } else {
                this.setState({ restictedWord: null });
            }
        }
        if (control.islinkpagevarible) {

            var token = this.props.token;
            var menu = ControlService().deepcopy(token.menu);
            var currentUrl = window.location.pathname;
            if (currentUrl.indexOf('/forms/Edit') > -1) {
                currentUrl = "/forms/Edit";
            }
            ControlService().loop(menu['Nav'], currentUrl.substring(1), (item, index, arr) => {
                item.Params.forEach(_item => {
                    if ((_item.name === control.pagevariblelink && _item.value !== "&") && (_item.attribute === control.pagevariblelink && _item.value !== "&")) {
                        _item.value = data[control.key];
                    }
                });
            });

            token.menu = menu;
            this.props.authSetToken(token);
        }
    }
    isTextOrNumber(control, value) {
        var isText = false;
        var isNumber = false;
        if (control.textonly) {
            isText = /^[a-zA-Z\s]*$/.test(value) ? true : false;
        } else if (control.numberonly) {
            isNumber = /^[0-9]*$/.test(value) ? true : false;
        }

        return isText || isNumber;
    }
    onValueChange(value, control, action, formid) {
        var isUpdate = false;
        if (control.textonly || control.numberonly) {
            if (this.isTextOrNumber(control, value)) {
                if (control.charlimit) {
                    if (value.length <= control.charlimit) {
                        this.props.update(control.key, value, formid);
                        isUpdate = true;
                    }
                } else {
                    this.props.update(control.key, value, formid);
                    isUpdate = true;
                }
            }
        } else if (control.charlimit) {
            if (value.length <= control.charlimit) {
                this.props.update(control.key, value, formid);
                isUpdate = true;
            }
        } else {
            this.props.update(control.key, value, formid);
            isUpdate = true;
        }
        if (isUpdate) {
            var validation = ControlService().validate(control, value);
            var formValidation = this.props.data[formid + "_validation"] ? this.props.data[formid + "_validation"] : {}
            if (validation && (!formValidation[control.key] || formValidation[control.key].status != "pass")) {
                this.props.update(control.key, { "status": "pass", "control": control, touched: false }, formid + "_validation")
            } else if (!validation && (!formValidation[control.key] || formValidation[control.key].status != "fail")) {
                this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation")
            }
        }

        if (!value && control.refreshcomponenton && control.refreshcomponenformid) {
            this.props.update(control.refreshcomponenton + '_refresh', uuidv4(), control.refreshcomponenformid + 'write')
        }
    }
    controlVaildationCheck(props) {
        const { control, formid, data } = props;
        var _data = data[formid] ? data[formid][control.key] : null
        var validation = ControlService().validate(control, _data);
        if (validation) {
            this.props.update(control.key, { "status": "pass", "control": control, touched: false }, formid + "_validation")
        } else {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation")
        }
    }
    handleBlur = () => {
        this.setState({
            touched: true,
        });
        debugger;
        const { control, formid } = this.props;
        var value = this.state.value;
        if (value !== value.trim()) {
            this.props.update(control.key, value.trim(), formid);
        }
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, this.state.value);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;

        return validate ? !validate : shouldShow;
    }
    getMaskInput() {
        return [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
    render() {
        const { control, action, formid } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control, data);
        return (
            <div className={control.key == 'searchfilterbox' ? "" : "form-group"}>
                {control.label &&
                    <label htmlFor={control.id}>
                        {control.label}
                        {control.require &&
                            <sup className="text-danger font-weight-bold">*</sup>
                        }
                        {control.showhelptext &&
                            <span className={"custom-tooltip"}>
                                <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                            </span>
                        }
                    </label>
                }
                {
                    control.enableMaskInput ?
                        <MaskedInput
                            aria-label={control.label}
                            mask={[/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                            className={'form-control ' + (shouldMarkError || this.state.isExist ? "border-danger" : "")}
                            style={{ 'minWidth': '70px' }}
                            value={this.state.value}
                            placeholder={control.placeholder}
                            guide={control.guide}
                            id={control.id}
                            onBlur={() => { this.handleBlur(); this.updatePageVarible(control, data, formid) }}
                            onChange={(e) => this.onValueChange(e.target.value, control, action, formid)}
                        />
                        :
                        <input
                            type="text"
                            aria-label={control.label}
                            id={control.id}
                            onBlur={() => { this.handleBlur(); this.updatePageVarible(control, data, formid) }}
                            className={'form-control ' + (shouldMarkError || this.state.isExist ? "border-danger" : "")}
                            style={{ 'minWidth': '70px' }}
                            placeholder={control.placeholder}
                            onChange={(e) => this.onValueChange(e.target.value, control, action, formid)}
                            value={this.state.value}
                            onKeyDown={this.keypress.bind(this, control, this.state.typingTimer, this.state.value)}
                            onKeyUp={this.keyup.bind(this, control, this.state.value)}
                            onCopy={(e) => this.disablecopypaste(e, control)}
                            onPaste={(e) => this.disablecopypaste(e, control)}
                            onCut={(e) => this.disablecopypaste(e, control)}
                            onContextMenu={(e) => this.disablecopypaste(e, control)}
                            disabled={(control.disabled || this.props.disabled) ? true : false}
                        />
                }
                {(shouldMarkError && !this.state.value) &&
                    <small className="form-text text-danger">
                        {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                    </small>
                }
                {(this.state.isExist && this.state.value) &&
                    <small className="form-text text-danger">
                        {control.label} <b>{this.state.value}</b>{control.autovalidatemsg ? (' ' + control.autovalidatemsg) : ' already exists'}.
                    </small>
                }
                {(this.state.value && shouldMarkError) &&
                    <small className="form-text text-danger">
                        You can enter maximum {control.charlimit} characters.
                    </small>
                }
            </div>
        );
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value) => dispatch(updateFilterData(key, value)),
        authSetToken: (data) => dispatch(Actions.authSetToken(data))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
    token: state.formLoginReducer.token,
});
export default connect(mapStateToProps, bindAction)(Textbox);